import React from "react";
import withRouter from "../../../components/Common/withRouter";
import { DF_CO0004Context } from "./context";
import GridBody from "./Grid/GridBody";
import { Alert, Container } from "reactstrap";

const DF_CO0004 = (props) => {
  console.log("🤖 %cTransação [DF_CO0004]", "color:green");

  document.title = "Defender | Anular Itens da Nota Fiscal";
  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);

  if (!parseParams.get("ID_Arquivo")) {
    return (
      <Alert color="danger">
        Não é possível acessar essa transação sem parametros
      </Alert>
    );
  }

  return (
    <>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <DF_CO0004Context.Provider value={{ parseParams }}>
        <div className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridBody />
          </Container>
        </div>
      </DF_CO0004Context.Provider>
    </>
  );
};

export default withRouter(DF_CO0004);
